import { useState, useEffect } from 'react';
import Modal from '../Modal/Modal';
import Button from '../Button/Button';
import './PromptModal.css';

/**
 * Reusable form modal for simple name + description inputs
 * (used for creating account groups and accounts).
 */
const PromptModal = ({
  open,
  title,
  submitLabel = 'Create',
  nameLabel = 'Name',
  namePlaceholder = '',
  descriptionLabel = 'Description',
  descriptionPlaceholder = '',
  showDescription = true,
  onSubmit,
  onClose,
}) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');

  useEffect(() => {
    if (open) {
      setName('');
      setDescription('');
    }
  }, [open]);

  const handleSubmit = async (e) => {
    e?.preventDefault();
    if (!name.trim()) return;
    await onSubmit({ name: name.trim(), description: description.trim() });
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      footer={
        <>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={handleSubmit} disabled={!name.trim()}>
            {submitLabel}
          </Button>
        </>
      }
    >
      <form className="prompt-form" onSubmit={handleSubmit}>
        <label className="prompt-label">
          {nameLabel}
          <input
            className="prompt-input"
            autoFocus
            value={name}
            placeholder={namePlaceholder}
            onChange={(e) => setName(e.target.value)}
          />
        </label>
        {showDescription && (
          <label className="prompt-label">
            {descriptionLabel}
            <textarea
              className="prompt-input prompt-textarea"
              value={description}
              placeholder={descriptionPlaceholder}
              onChange={(e) => setDescription(e.target.value)}
              rows={3}
            />
          </label>
        )}
      </form>
    </Modal>
  );
};

export default PromptModal;
